import React from 'react';
import PropTypes from 'prop-types';
import { HeroImg } from './hero.css';
import Hero01 from '../../../static/hero_01.jpg';
import Hero03 from '../../../static/hero_03.jpg';

const Hero = ({ queryParams }) => {
  return (
    <HeroImg src={queryParams && queryParams.v === '2' ? Hero03 : Hero01}>
      <p>
        Get the best deal
        <br />
        for your home!
      </p>
    </HeroImg>
  );
};

Hero.propTypes = {
  queryParams: PropTypes.object,
};

export default Hero;
